/* [RR feat] Bewertungen (Judge.me-Daten): Reiter, Weiterlesen, Fotos vergrößern,
   Judge.me-Widget einblenden. Alles ohne Nachladen; die Daten stehen im HTML. */
(function () {
  'use strict';

  class RrBewertungen extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-rr-card]'));
      this.grid = this.querySelector('[data-rr-cards]');
      this.lightbox = this.querySelector('[data-rr-lightbox]');
      this.step = Math.max(1, parseInt(this.dataset.initial, 10) || 3);
      this.shown = this.step;
      this.addEventListener('click', this.onClick.bind(this));
      this.applyVisible();
      this.clamp();
      /* Ohne Judge.me-Widget auf der Seite (Section deaktiviert) gibt es kein Formular
         und keine weitere Liste: die beiden Knöpfe dann ausblenden. */
      if (!this.findJudgeMe()) {
        this.querySelectorAll('[data-rr-write], [data-rr-all]').forEach((b) => { const w = b.closest('bd-icon-curve') || b; w.hidden = true; });
      }
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.clamp());
        this.ro.observe(this);
      }
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeLightbox(); });
    }

    disconnectedCallback() { if (this.ro) this.ro.disconnect(); }

    /* „Weiterlesen“ nur, wenn der Text wirklich abgeschnitten ist */
    clamp() {
      this.cards.forEach((card) => {
        const body = card.querySelector('[data-rr-body]');
        const btn = card.querySelector('[data-rr-readmore]');
        if (!body || !btn || card.hidden || card.dataset.expanded === 'true') return;
        body.classList.add('is-clamped');
        const cut = body.scrollHeight > body.clientHeight + 2;
        btn.hidden = !cut;
        if (!cut) body.classList.remove('is-clamped');
      });
    }

    onClick(e) {
      const t = e.target.closest('[data-rr-sort], [data-rr-readmore], [data-rr-photo], [data-rr-lightbox-close], [data-rr-write], [data-rr-all], [data-rr-more]');
      if (!t) { if (e.target === this.lightbox) this.closeLightbox(); return; }

      if (t.hasAttribute('data-rr-sort')) { this.sort(t.dataset.rrSort); this.querySelectorAll('[data-rr-sort]').forEach((b) => { const on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); }); return; }
      if (t.hasAttribute('data-rr-readmore')) { const card = t.closest('[data-rr-card]'); card.dataset.expanded = 'true'; card.querySelector('[data-rr-body]').classList.remove('is-clamped'); t.hidden = true; return; }
      if (t.hasAttribute('data-rr-photo')) { this.openLightbox(t.dataset.rrPhoto); return; }
      if (t.hasAttribute('data-rr-lightbox-close')) { this.closeLightbox(); return; }
      if (t.hasAttribute('data-rr-write')) { this.showJudgeMe(true); return; }
      if (t.hasAttribute('data-rr-all')) { this.showJudgeMe(false); return; }
      if (t.hasAttribute('data-rr-more')) { this.shown += this.step; this.applyVisible(); this.clamp(); return; }
    }

    /* Nur die ersten N Karten zeigen; „Weitere laden“ holt den nächsten Schritt aus dem HTML.
       Sind alle sichtbar, bleibt der Sprung zum Judge.me-Widget mit allen Bewertungen. */
    applyVisible() {
      const order = Array.prototype.slice.call(this.grid.querySelectorAll('[data-rr-card]'));
      order.forEach((c, i) => { c.hidden = i >= this.shown; });
      const more = this.querySelector('[data-rr-more]');
      const all = this.querySelector('[data-rr-all]');
      const rest = order.length > this.shown;
      if (more) more.hidden = !rest;
      if (all) all.hidden = rest;
    }

    /* Reihenfolge der Karten: mit Foto zuerst (dann nach Datum) oder rein nach Datum */
    sort(mode) {
      const sorted = this.cards.slice().sort((a, b) => {
        if (mode === 'photos') {
          const pa = Number(a.dataset.photos) > 0 ? 1 : 0, pb = Number(b.dataset.photos) > 0 ? 1 : 0;
          if (pa !== pb) return pb - pa;
        }
        return (b.dataset.date || '').localeCompare(a.dataset.date || '');
      });
      sorted.forEach((c) => this.grid.appendChild(c));
      this.applyVisible();
      this.clamp();
    }

    openLightbox(src) {
      if (!this.lightbox || !src) return;
      this.lightbox.querySelector('img').src = src;
      this.lightbox.hidden = false;
      document.body.classList.add('overflow-hidden');
    }

    closeLightbox() {
      if (!this.lightbox || this.lightbox.hidden) return;
      this.lightbox.hidden = true;
      this.lightbox.querySelector('img').src = '';
      document.body.classList.remove('overflow-hidden');
    }

    /* Das offizielle Judge.me-Widget einblenden (Formular, alle Bewertungen) */
    findJudgeMe() {
      const id = this.dataset.jmSection;
      let sec = id ? document.getElementById('shopify-section-' + id) : null;
      if (!sec) sec = document.querySelector('.shopify-section:has(.jdgm-widget, .jm-review-widget, .jdgm-widget-revamp)');
      return sec;
    }

    showJudgeMe(openForm) {
      const sec = this.findJudgeMe();
      if (!sec) return;
      sec.classList.add('rr-bew-jm-visible');
      sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (openForm) {
        window.setTimeout(() => {
          const btn = sec.querySelector('.jdgm-write-rev-link, .jm-review-widget__write-btn, [class*="write-review"], button[class*="write"]');
          if (btn) btn.click();
        }, 400);
      }
    }
  }

  if (!customElements.get('rr-bewertungen')) customElements.define('rr-bewertungen', RrBewertungen);
})();
